module.exports = __webpack_public_path__ + "img/14.6579ed43.jpg";